import { useQuery } from "@tanstack/react-query";
import { useAccessControl } from "../../app/use-access-control";
import { callLcosService } from "../../data/lcosServices";
import { useAccessToken } from "../use-access-token";
import { familyQueryKeys } from "./query-keys";
import { FamilySelectionOption } from "./types";

interface UseFamilySelectionProps {
  inquirerId?: number;
  studentId?: number;
}

interface FamilySelectionListResponse {
  families: Array<Pick<FamilySelectionOption, "id"> & { name?: string }>;
}

export const useFamilySelection = ({ inquirerId, studentId }: UseFamilySelectionProps) => {
  const { getToken } = useAccessToken();
  const { activeCenterId } = useAccessControl();

  return useQuery({
    queryKey: familyQueryKeys.selection(activeCenterId, inquirerId, studentId),
    enabled: !!inquirerId && inquirerId > 0 && !!studentId && studentId > 0,
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    queryFn: async () => getFamilySelectionList(await getToken(), activeCenterId, inquirerId!, studentId!),
    select: (data): FamilySelectionOption[] =>
      data.families.map(family => ({
        id: family.id,
        name: family.name ?? ""
      }))
  });
};

const getFamilySelectionList = (accessToken: string, centerId: string, inquirerId: number, studentId: number) => {
  return callLcosService<FamilySelectionListResponse>(
    accessToken,
    `/api/centers/${centerId}/families/contact_families?contact_id=${inquirerId}&contact_id=${studentId}`,
    "GET"
  );
};
